import { Component, OnInit, Input } from '@angular/core';
 import { StandService } from 'src/app/service/stand.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Stand } from 'src/app/entity/Stand';
import { MatTableDataSource } from '@angular/material/table';
 
 
@Component({
  selector: 'app-clients-projet',
  templateUrl: './clients-projet.component.html',
  styleUrls: ['./clients-projet.component.css']
})
export class ClientsProjetComponent implements OnInit {

  constructor(private standService:StandService,private exhibitorService:ExhibitorService) { }

@Input() projectId: number;
@Input() clientId: number;
@Input() showListStands: boolean;

   shwoAssigned=false;
   dataSource=new MatTableDataSource();
   columnsToShow= ['text1','text3',"action" ]

  ngOnInit() {
    this.exhibitorService.subscribeConstructeurClient(this.clientId);
    this.findExhibitor();
  }
  findExhibitor() {
    this.exhibitorService.findAllExhibitors( ).subscribe(data => {
      this.dataSource.data = data;
 
    })

  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


 async affectConstructeurClient(clientConstructeurId: number) {
 
 await  this.exhibitorService.affectConstructeurClient( clientConstructeurId,this.clientId );
 
 this.exhibitorService.subscribeConstructeurClient(this.clientId);
 this.showListStands=false
  }
  onShowAll(){
    if(this.shwoAssigned)
    this.columnsToShow= ['num','standType','superficie','clients','action']
else
    this.columnsToShow= ['num','standType','superficie' ,'action']

 
  }
}
